import styled from 'styled-components';

export const UserHeading = styled.div`
    font-size: 10px;
    text-align: center;
`